import React from 'react';
import { useData } from '../../context/DataContext';
import { computeGroupStats } from '../../utils/calculations';

export const AbsenteesTable = ({ onDrilldown }) => {
  const { currentBranchFilter, getScopedStudents,participationCounts } = useData();

  const scoped = getScopedStudents();
  const isScoped = currentBranchFilter !== 'all';

  let rows = [];
  if (!isScoped) {
    // School-wise absentees (Admin mode)
    const branches = [...new Set(scoped.map(s => s.school).filter(Boolean))];
    rows = branches.map(branch => {
      const stats = computeGroupStats(scoped.filter(s => s.school === branch));
      const absent = stats.total - stats.participated;
      const absentPct = stats.total > 0 ? Math.round((absent / stats.total) * 100) : 0;
      return {
        label: branch,
        total: stats.total,
        participated: stats.participated,
        absent,
        absentPct,
        onClick: () => onDrilldown({ type: 'school', value: branch, initialStatus: 'absent' })
      };
    });
  } else {
    // Section-wise absentees (Scoped school mode)
    const sectionGroups = {};
    scoped.forEach(s => {
      const key = `${s.registeredGrade}-${s.section || 'Unassigned'}`;
      if (!sectionGroups[key]) {
        sectionGroups[key] = { grade: s.registeredGrade, section: s.section || 'Unassigned', students: [] };
      }
      sectionGroups[key].students.push(s);
    });

  //   rows = Object.values(sectionGroups).map(g => {
  //     const stats = computeGroupStats(g.students);
  //     const absent = stats.total - stats.participated;
  //     const absentPct = stats.total > 0 ? Math.round((absent / stats.total) * 100) : 0;
  //     return {
  //       label: `Grade ${g.grade} - ${g.section}`,
  //       total: stats.total,
  //       participated: stats.participated,
  //       absent,
  //       absentPct,
  //       onClick: () => onDrilldown({
  //         type: 'gradeSection',
  //         value: { grade: g.grade, section: g.section },
  //         initialStatus: 'absent'
  //       })
  //     };
  //   });
  // }
   rows = participationCounts.filter((G) => G.Grade !== "Total").map(g => {
      // const stats = computeGroupStats(g.students);
      const absent = g.Absent;
      // const absent = stats.total - stats.participated;
      const absentPct = g.Registered > 0 ? Math.round((absent / g.Registered) * 100) : 0;
      // const absentPct = stats.total > 0 ? Math.round((absent / stats.total) * 100) : 0;
      return {
        label: `Grade ${g.GradeSection}`,
        total: g.Registered,
        participated: g.Participated,
        absent,
        absentPct,
        onClick: () => onDrilldown({
          type: 'gradeSection',
          value: { grade: g.Grade, section: g.Section },
          initialStatus: 'absent'
        })
      };
    });
  }

  // Sort by highest number of absentees first
  rows.sort((a, b) => b.absent - a.absent);
  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg border-2 border-gray-100 mb-6 select-none">
      <div className="flex justify-between items-start mb-4 flex-wrap gap-4">
        <div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">
            {isScoped ? 'Section-wise Absentees' : 'School-wise Absentees'}
          </h3>
          <p className="text-sm text-gray-600">
            {isScoped ? 'Students who did not participate, by grade & section.' : 'Students who did not participate, by branch.'}{' '}
            <span className="text-xs italic text-gray-500 font-bold">*Click "View List" to see those students.</span>
          </p>
        </div>
      </div>

      <div className="overflow-x-auto rounded-xl border border-gray-200">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="bg-red-600 text-white">
              <th className="text-left py-3 px-4 font-bold border border-red-700">
                {isScoped ? 'Section' : 'School'}
              </th>
              <th className="text-center py-3 px-4 font-bold border border-red-700">Total Registered</th>
              <th className="text-center py-3 px-4 font-bold border border-red-700">Participated</th>
              <th className="text-center py-3 px-4 font-bold border border-red-700">Absent</th>
              <th className="text-center py-3 px-4 font-bold border border-red-700">Absent %</th>
              <th className="text-center py-3 px-4 font-bold border border-red-700">Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-10 text-gray-400 italic">
                  No data available.
                </td>
              </tr>
            ) : (
              rows.map((r, idx) => (
                <tr key={idx} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-3 px-4 font-semibold text-gray-800 border border-gray-200">{r.label}</td>
                  <td className="py-3 px-4 text-center border border-gray-200">{r.total}</td>
                  <td className="py-3 px-4 text-center font-bold text-green-600 border border-gray-200">{r.participated}</td>
                  <td className="py-3 px-4 text-center font-bold text-red-600 border border-gray-200">{r.absent}</td>
                  <td
                    className="py-3 px-4 text-center font-bold border border-gray-200"
                    style={{
                      color: r.absentPct >= 25 ? '#dc2626' : r.absentPct >= 10 ? '#d97706' : '#16a34a'
                    }}
                  >
                    {r.absentPct}%
                  </td>
                  <td className="py-3 px-4 text-center border border-gray-200">
                    <button
                      onClick={r.onClick}
                      className="text-xs bg-red-50 text-red-600 px-3 py-1.5 rounded border border-red-200 hover:bg-red-100 font-bold transition-colors cursor-pointer"
                    >
                      View List
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default AbsenteesTable;
